<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onCancelClick()">
                </div>
                <hr>
                <div>
                    <div class="modal-form">
                        <form [formGroup]="offerForm" #data>
                            <div class="col col-12 mainSections marginTop">
                                <h5 class="headingText">Offer Name</h5>
                                <input class="form-control" type="text" placeholder="Offer Name" formControlName="name"
                                    [ngClass]="{ 'is-invalid': submitted && setOfferControls.name.errors}">
                                <div class="text-danger">
                                    <div class="" *ngIf="submitted && setOfferControls.name.errors">
                                        Name is required </div>
                                </div>
                            </div>
                            <div class="col col-12 mainSections marginTop">
                                <h5 class="headingText">Value (% or fixed)</h5>
                                <input class="form-control" type="number" placeholder="Value" formControlName="value"
                                    [ngClass]="{ 'is-invalid': submitted && setOfferControls.value.errors}">
                                <div class="text-danger">
                                    <div class="" *ngIf="submitted && setOfferControls.value.errors">
                                        Value is required </div>
                                </div>
                            </div>
                            <div class="col col-12 mainSections marginTop">
                                <h5 class="headingText">Start Date</h5>
                                <div class="datepicker">
                                    <input id="startDate" type="text" placeholder="Start Date"
                                        class="form-control datepicker-input2" bsDatepicker
                                        [(ngModel)]="selectedStartDate" style="cursor: pointer;" formControlName="from"
                                        [bsConfig]="{ adaptivePosition: true, dateInputFormat:'YYYY-MM-DD', containerClass: 'theme-dark-blue'}"
                                        placement="top right"
                                        [ngClass]="{ 'is-invalid': submitted && setOfferControls.from.errors}">

                                    <span id="iconCalendar">
                                        <img src="../../../../../assets/icons/calendar.png" width="18px" height="18px"
                                            class="d-inline-block align-top" alt="" loading="lazy">
                                    </span>
                                </div>
                                <div class="text-danger">
                                    <div class="" *ngIf="submitted && setOfferControls.from.errors">
                                        Start date is required </div>
                                </div>
                            </div>
                            <div class="col col-12 mainSections marginTop">
                                <h5 class="headingText">End Date</h5>
                                <div class="datepicker">
                                    <input id="startDate" type="text" placeholder="End Date"
                                        class="form-control datepicker-input2" bsDatepicker
                                        [(ngModel)]="selectedExpireyDate" style="cursor: pointer;" formControlName="to"
                                        [bsConfig]="{ adaptivePosition: true, dateInputFormat:'YYYY-MM-DD', containerClass: 'theme-dark-blue'}"
                                        placement="top right"
                                        [ngClass]="{ 'is-invalid': submitted && setOfferControls.to.errors}">

                                    <span id="iconCalendar">
                                        <img src="../../../../../assets/icons/calendar.png" width="18px" height="18px"
                                            class="d-inline-block align-top" alt="" loading="lazy">
                                    </span>
                                </div>
                                <div class="text-danger">
                                    <div class="" *ngIf="submitted && setOfferControls.to.errors">
                                        End date is required </div>
                                </div>
                            </div>
                            <div class="col col-12 mainSections marginTop">
                                <h5 class="headingText">Description for customer</h5>
                                <input class="form-control" type="text" placeholder="Description for customer"
                                    formControlName="description"
                                    [ngClass]="{ 'is-invalid': submitted && setOfferControls.description.errors}">
                                <div class="text-danger">
                                    <div class="" *ngIf="submitted && setOfferControls.description.errors">
                                        Description is required </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-button" type="button"
                            (click)="modalType == 'Add' ? onAddClick() : onEditClick()">
                            <span *ngIf="!loading">{{modalType == 'Add' ? 'Add Offer' : 'Save'}}</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>